const constants = require('@/util/constants')
require('./config')

/**
 * 获取webs
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getWebs (page, size, successcb, failedcb) {
  axios.get('/api/app/webs', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建 web
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createWeb (name, url, description, successcb, failedcb) {
  axios.post('/api/app/web/create', {
    name,
    url,
    description,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新 web
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateWeb (aid, name, url, description, successcb, failedcb) {
  axios.post('/api/app/web/update', {
    aid,
    name,
    url,
    description,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除 web
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteWeb (aid, successcb, failedcb) {
  axios.post('/api/app/web/delete', {
    aid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取apps
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getApps (page, size, successcb, failedcb) {
  axios.get('/api/app/apps', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建 app
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createApp (name, avatar, version, tip, url, status, platform, description, successcb, failedcb) {
  axios.post('/api/app/app/create', {
    name,
    avatar,
    version,
    tip,
    url,
    status,
    platform,
    description,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新 app
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateApp (aid, name, avatar, version, tip, url, status, platform, description, successcb, failedcb) {
  axios.post('/api/app/app/update', {
    aid,
    name,
    avatar,
    version,
    tip,
    url,
    status,
    platform,
    description,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除 app
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteApp (aid, successcb, failedcb) {
  axios.post('/api/app/app/delete', {
    aid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取mps
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getMps (page, size, successcb, failedcb) {
  axios.get('/api/app/mps', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建 mp
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createMp (nickname, number, description, company,
  originalId, appId, appSecret, aesKey, encodeType,
  successcb, failedcb) {
  axios.post('/api/app/mp/create', {
    nickname,
    number,
    description,
    company,
    originalId,
    appId,
    appSecret,
    aesKey,
    encodeType,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新 mp
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateMp (wid, nickname, number, description, company,
  originalId, appId, appSecret, aesKey, encodeType,
  successcb, failedcb) {
  axios.post('/api/app/mp/update', {
    wid,
    nickname,
    number,
    description,
    company,
    originalId,
    appId,
    appSecret,
    aesKey,
    encodeType,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除 mp
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteMp (wid, successcb, failedcb) {
  axios.post('/api/app/mp/delete', {
    wid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取minis
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getMinis (page, size, successcb, failedcb) {
  axios.get('/api/app/minis', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建 mini
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createMini (nickname, description, company,
  originalId, appId, appSecret, aesKey, encodeType, dataType,
  successcb, failedcb) {
  axios.post('/api/app/mini/create', {
    nickname,
    description,
    company,
    originalId,
    appId,
    appSecret,
    aesKey,
    encodeType,
    dataType,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新 mini
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateMini (wid, nickname, description, company,
  originalId, appId, appSecret, aesKey, encodeType, dataType,
  successcb, failedcb) {
  axios.post('/api/app/mini/update', {
    wid,
    nickname,
    description,
    company,
    originalId,
    appId,
    appSecret,
    aesKey,
    encodeType,
    dataType,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除 mini
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteMini (wid, successcb, failedcb) {
  axios.post('/api/app/mini/delete', {
    wid,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
